<template>
     <div>
        <review-detail-link v-for="writeLayout in writeLayouts" :key="`review${writeLayout}`"
                            :writeLayout="writeLayout" :reviewData="reviewData"></review-detail-link>
    </div>
   <!-- <div class="c_table_wrap">
        <div class="sub_title sub_title_review">기본 정보</div>
        <table>
            <colgroup>
                <col width="200px">
                <col>
                <col width="200px">
                <col>
            </colgroup>
            <tr>
                <td class="c_t_title">작성일</td>
                <td colspan="3">
                    <div>
                        {{ returnDateFormat(reviewData.created_at, 'YYYY-MM-DD HH:mm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">작성자 닉네임</td>
                <td colspan="3">
                    <el-link type="primary" @click="$router.push(`/member/${reviewData.mb_no}`)">
                        {{ reviewData.mb_nick }}
                    </el-link>
                </td>
            </tr>
            <tr v-if="reviewType == 'detailMagazine'">
                <td class="c_t_title">매거진</td>
                <td colspan="3">
                    <div>
                        {{ reviewData.p_title }}
                    </div>
                </td>
            </tr>
            <tr v-if="reviewType == 'detailStyling'">
                <td class="c_t_title">스타일명</td>
                <td colspan="3">
                    <div>
                        {{returnStyle(reviewData.es_key)}}
                    </div>
                </td>
            </tr>
            <tr v-if="reviewType == 'detailStyling'">
                <td class="c_t_title">스타일</td>
                <td colspan="3">
                    <div>
                        {{ reviewData.p_title }}
                    </div>
                </td>
            </tr>
            <tr v-if="reviewType == 'detailStyling'">
                <td class="c_t_title">제품</td>
                <td colspan="3">
                    <div>
                        {{ reviewData.p_title }}
                    </div>
                </td>
            </tr>
        </table>

        <div class="sub_title sub_title_review">리뷰 정보</div>
        <table>
            <colgroup>
                <col width="200px">
                <col>
                <col width="200px">
                <col>
            </colgroup>
            <tr>
                <td class="c_t_title">만족도</td>
                <td colspan="3">
                    <div>
                        {{returnReview(reviewData.pr_review)}}
                    </div>
                </td>
            </tr>
            <tr v-if="reviewType == 'detailMagazine' && reviewData.pr_review !== 2">
                <td class="c_t_title">내용</td>
                <td colspan="3">
                    <div>
                        {{ returnContent(reviewData.content) }}
                    </div>
                </td>
            </tr>
            <tr v-else>
                <td class="c_t_title">매거진</td>
                <td colspan="3">
                    <div>
                        {{ reviewData.p_title }}
                    </div>
                </td>
            </tr>
        </table>
        <div class="mt60">
            <el-button type="danger" @click="runDeleteNonPasswordConfirm()">리뷰 삭제</el-button>
        </div>
    </div> -->
</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import reviewUtil from "@/components/review/reviewUtil";
import ReviewDetailLink from "@/components/review/link/ReviewDetailLink";

export default {
    name: "ReviewDetailComponent",
    mixins: [dateMixins, alertMixins, reviewUtil],
    components: {ReviewDetailLink},
    inject: [],
    provide() {
        return {
            runDelete: this.runDeleteNonPasswordConfirm
        }
    },
    props: {
        reviewType: {default: ''},
        reviewKey: {default: 0},
        defaultParams: {
            default: () => {
            }
        },
    },
    data() {
        return {
            reviewData: {},
            getFunc: '',
            detailApiParamSet: {},
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            keyName: '',
            DeleteClass: null,
            directUrl: '',
            directType: ''
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        this.getReview();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnReviewConfig(this.reviewType);
            this.writeLayouts = config.writeLayouts;
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.keyName = config.keyName;
            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.directUrl = config.directUrl;
            this.directType = config.directType;

            this.newDeleteClass()
        },

        getReview() {
            this.detailApiParamSet = Object.assign({},  this.detailApiParamSet, this.defaultParams)
            let params = Object.assign({}, this.detailApiParamSet);

            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$review[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert('데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        return false;
                    }
                    this.reviewData = res.List[0];
                    EventBus.$emit('changeLoading', false);
                })
            } catch (e) {
                console.log((e));
                EventBus.$emit('changeLoading', false);
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$review[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDeleteNonPasswordConfirm() {
            this.createConfirm({
                title: '리뷰 삭제',
                customClass:'eot_pop',
                content: '정말로 삭제하시겠습니까?<br/>삭제 후에는 복구가 불가능합니다.',
                confirm: () => {
                    this.runDelete(this.reviewKey);
                }
            })
        },

        runDelete(key) {
            let sendKey = []
            sendKey.push(key)
            EventBus.$emit('changeLoading', true);
            this.DeleteClass.runExampleWordDelete(sendKey)
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },

    },
    watch: {
    },
}
</script>

<style scoped>

</style>
